import { render, staticRenderFns } from "./ShowRich.vue?vue&type=template&id=3774072f&"
import script from "./ShowRich.vue?vue&type=script&lang=js&"
export * from "./ShowRich.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports